export default {
  LOAD_MY_CLAIM_FORM_PAGE_START: 'LoadMyGeneralCompetencyClaimFormPageStart',
  LOAD_MY_CLAIM_FORM_PAGE_END: 'LoadMyGeneralCompetencyClaimFormPageEnd',
  UPLOAD_ATTACHMENT_START: 'UploadMyGeneralCompetencyClaimAttachmentStart',
  UPLOAD_ATTACHMENT_END: 'UploadMyGeneralCompetencyClaimAttachmentEnd',
  TOGGLE_DELETE_ATTACHMENT_DIALOG: 'ToggleDeleteMyGeneralCompetencyClaimAttachmentDialog',
  DELETE_ATTACHMENT_END: 'DeleteMyGeneralCompetencyClaimAttachmentEnd',
  CLEAR_UPLOAD_ERROR: 'ClearMyGeneralCompetencyClaimUploadError',
  CLEANUP_MY_CLAIM_FORM_PAGE: 'CleanupMyGeneralCompetencyClaimFormPage'
};
